document.addEventListener('click', function (e) {
  const trigger = e.target.closest(
    '.dropdown-icon.dropdown-icon--chevron.dropdown-icon--first-level, .button-dropdown-icon, .button-dropdown-icon .dropdown-icon'
  );

  if (!trigger) return;

  const currentSummary = trigger.closest('summary');
  if (!currentSummary) return;

  setTimeout(() => {
    let selector = '';
    let scopeContainer = null;

    if (currentSummary.classList.contains('top-level-item')) {
      selector = ':scope > li > drawer-menu > summary.top-level-item';
      scopeContainer = currentSummary.closest('.menu__list');
    } else if (currentSummary.classList.contains('second-level-item')) {
      selector = ':scope > li > drawer-menu > summary.second-level-item';
      scopeContainer = currentSummary.closest('.first-nested__list');
    } else if (currentSummary.classList.contains('third-level-item')) {
      selector = ':scope > li > drawer-menu > summary.third-level-item';
      scopeContainer = currentSummary.closest('.second-nested__list');
    } else {
      return;
    }

    if (!scopeContainer) return;

    const summaries = scopeContainer.querySelectorAll(selector);

    summaries.forEach((summary) => {
      if (summary === currentSummary) return;
      closeMenuBranch(summary);
    });
  }, 0);

  function closeMenuBranch(summary) {
    summary.setAttribute('open', 'false');

    const drawer = summary.closest('drawer-menu');
    if (drawer) {
      drawer.setAttribute('open', 'false');
    }

    const parentLi = summary.closest('li');
    if (!parentLi) return;

    const nestedSummaries = parentLi.querySelectorAll(
      'summary.second-level-item, summary.third-level-item'
    );

    nestedSummaries.forEach((nestedSummary) => {
      if (nestedSummary === summary) return;

      nestedSummary.setAttribute('open', 'false');

      const nestedDrawer = nestedSummary.closest('drawer-menu');
      if (nestedDrawer) {
        nestedDrawer.setAttribute('open', 'false');
      }
    });
  }
});